import React from 'react';
import classNames from 'classnames';
import { createRocket } from '@tencent/tea-component/lib/_util/create-rocket';
function BuyLayoutHeader(_a) {
    var className = _a.className, style = _a.style, title = _a.title, subtitle = _a.subtitle, extra = _a.extra;
    return (React.createElement("section", { className: classNames('buy-layout-header', className), style: style },
        React.createElement("div", { className: "buy-layout-header-inner" },
            React.createElement("div", { className: "buy-layout-header-title" }, title),
            subtitle && (React.createElement("div", { className: "buy-layout-header-sub-title" },
                React.createElement("div", { className: "buy-divider buy-divider-vertical" }),
                subtitle)),
            extra && React.createElement("div", { className: "buy-layout-header-extra" }, extra))));
}
var BuyLayoutBody = createRocket('BuyLayoutBody', 'section.buy-layout-body', 'div.buy-layout-body-inner');
var BuyLayoutMain = createRocket('BuyLayoutMain', 'div.buy-layout-main', 'div.buy-layout-main-inner');
var BuyLayoutSide = createRocket('BuyLayoutSide', 'aside.buy-layout-side', 'div.buy-layout-side-inner');
export var BuyLayout = Object.assign(createRocket('BuyLayout', 'section.buy-layout'), {
    Header: BuyLayoutHeader,
    Body: BuyLayoutBody,
    Main: BuyLayoutMain,
    Side: BuyLayoutSide,
});
//# sourceMappingURL=BuyLayout.js.map